import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import * as grid from 'view/styles/grid';

export const UnFeaturedPortalsWrapper = styled.section`
    margin-top: ${token('space.300', '24px')};
`;

export const EmptyPortalsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: ${grid.multiple(14).px} auto ${grid.multiple(14).px};
`;
